import PropTypes from 'prop-types'
import React from 'react'
import { GridItem } from '@sainsburys-tech/luna-react'
import { Link } from 'react-router-dom'

const Group = ({ group }) => (
  <GridItem className="ln-u-1/3@md" size="1/1">
    <div className="ln-c-label ln-u-soft-right">Group</div>
    {group && group.id ? (
      <Link className="ln-c-standalone-link" to={`/groups/${group.id}`}>
        {group.title}
      </Link>
    ) : (
      <span>There is no group.</span>
    )}
  </GridItem>
)

Group.propTypes = {
  group: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
  }),
}

Group.defaultProps = {
  group: null,
}

export default Group
